module.exports = __webpack_public_path__ + "images/assessmentLogo_7bf857a.svg";